<mat-radio-group [formControl]="control()">
  <mat-radio-button class="item-radio-button" [value]="item.id" *ngFor="let item of items()">
    <mat-card class="item-card">
      <div class="card-content">
        <div class="text-section">
          <div class="item-name">{{ item.name }}</div>
          <div class="item-description">{{ item.description }}</div>
        </div>
        <div class="image-section">
          <img [src]="item.imageDocument.url" [alt]="item.imageDocument.displayName" class="item-image" />
        </div>
      </div>
    </mat-card>
  </mat-radio-button>
</mat-radio-group>
